import {useState, useContext, useEffect} from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useMutation, useQuery } from '@tanstack/react-query';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import InductionInvitesTable from './Table';
import { useSettingModal } from '../../../hooks/Context';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';
import {RouteResponse} from '../../../types/index'
import {FetchAllRoutes, reOrderFetchedData} from '../../../hooks/FetchData'
import { NotificationContext } from '../../../providers/notification'; 
import apiCallFormData from '../../../utils/apiFormDataCall';
import { handleDownloadInduction } from '../../../utils/downloadUtils';
import { TopDisplay,Button,UploadButton,  FilterDropDown,DateFilter, } from '../../../ui-components';







const option1:any= [
    {val:ExNyRoute, name:"Examination / NYSC",path:``},
    {val:PrRoute, name:"Practitioner",path:`practitioner`},
    {val:ExRoute, name:"Executive",path:`executive`},
    {val:AcRoute, name:"Academic",path:`academic`},
    {val:MiRoute, name:"Military",path:`military`},
    {val:CoRoute, name:"Corporate",path:`corporate`}
  ]

  interface InductionInvites {
    ApplicantId: string;
    ApplicantName: string;
    ApplicantEmail: string;
    ApplicantPhone: string;
  }

interface  DisplayInductionInvitesProps {
    setRoute: React.Dispatch<React.SetStateAction<{
        name: string;
        val: number;
    } >>

    route?: {
        name: string;
        val: number;
    }
}



const DisplayInductionInvites = ({setRoute, route}: DisplayInductionInvitesProps)=>{

    const [searchData, setSearchData] = useState('');
    const {setShowModal,setModalContent} = useSettingModal()
    const [routeNameInt, setRouteNameInt] = useState('')

    const getInductionInvites = async () :Promise<InductionInvites[]> =>  (await apiCall().get(`/Activity/GetApplicantPendingInduction?routeId=${route?.val}&activity=Induction`))?.data?.Data

    const getInductionInvitesMutation = useMutation(['get-Induction-Invites'], getInductionInvites)

    const getInductionInvitesError = getInductionInvitesMutation?.error as AxiosError

    const {isLoading, data} = FetchAllRoutes();

    const reOrderedAllRoutes = data ? reOrderFetchedData((data as RouteResponse )?.Data) : []

    const allRoutes = isLoading ? [] : reOrderedAllRoutes.map((item) => {return {name: item?.RouteName, val: item?.RouteId}})
    const { showNotification } = useContext(NotificationContext);



    useEffect(() => {
        getInductionInvitesMutation.mutateAsync()
    }, [route])

    const handleRouteSwitch = (route:any) =>{
        setRoute(route);
        setRouteNameInt(route.name);
    }

    const InductionInvites = getInductionInvitesMutation?.data || []

    const filteredData = InductionInvites?.filter(x => (
      Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
    ));
  
  const [uploading, setUploading] = useState(false);

const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const body = new FormData();
  body.append("ExcelFile", file);

  setUploading(true);
  try {
    const response = await apiCallFormData().post(
      "/Applicant/UploadOfflineApplicantInduction",
      body,
      {
        responseType: "json", // expect JSON first
      }
    );

    showNotification({
      message:
        response?.data?.Message ||
        "Training file uploaded successfully",
      type: "success",
    });
  } catch (error: any) {
    const blob = error?.response?.data;

    // case 1: API returned JSON error message
    if (error?.response?.data?.Message) {
      showNotification({
        message: error.response.data.Message,
        type: "error",
      });
    }
    // case 2: API returned blob (like error report)
    else if (blob instanceof Blob) {
      // Try reading the blob as text first
      const text = await blob.text().catch(() => null);

      if (text) {
        try {
          const parsed = JSON.parse(text);
          showNotification({
            message: parsed?.Message || "Upload failed",
            type: "error",
          });
        } catch {
          // Not JSON → treat as file download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Payment_UploadErrorReport.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();

          showNotification({
            message:
              "Training upload failed — error report downloaded",
            type: "error",
          });
        }
      }
    } else {
      // fallback
      showNotification({
        message: error?.message || "File not uploaded",
        type: "error",
      });
    }
  } finally {
    setUploading(false);
    e.target.value = "";
  }
};



    return(
      <>
        <TopWrapper>
        <label className={styles.searchForm} ><span className={styles.sI}><SearchIcon/></span><input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' /><button className={styles.rBtn} type="submit"><ReloadIcon/></button></label>
          <FilterDropDown onChange={handleRouteSwitch} options={allRoutes} text={routeNameInt ? `${routeNameInt}` : 'Membership Route'} bg="#11643C" color="#fff"/>
          <UploadButton
              onChange={handleUpload}
              label={!uploading ? "Upload OffLine Induction Payment" : "Uploading..."}
            />
    
            <Button
              onClick={handleDownloadInduction}
              children="Download Offline Payment Template"
              border="#E2E4E9"
              bg="#11643C"
              color="#fff"
            />
          <div>

          </div>
        </TopWrapper>
        {getInductionInvitesMutation?.isLoading ? (
          <CircularProgress 
            sx={{
              fontSize: '1rem',
              marginInline: 'auto',
              display: 'block',
              marginBlock: '2rem'
            }}
          />
          ) : getInductionInvitesMutation?.isError ? (
              <StyledError>{getInductionInvitesError?.message}</StyledError>
          ) : filteredData && filteredData?.length  > 0  ? 
          <InductionInvitesTable data={searchData.length > 0 ? filteredData : InductionInvites}  /> 
          :<div>No Result</div> 
        }
      </>
    )
}

export default DisplayInductionInvites;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const TopWrapper = styled('div')`
  display:flex;
  gap:10px;
  align-items: center;
  margin: 10px 0px 48px 0px;
`
